(function () {
  // ---------- header/announcement-bar stack: offset vars + hide-on-scroll-down / reveal-on-scroll-up ----------
  // Drives the mobile `pr-nav-up` body class and the --pr-announce-height/
  // --header-height offsets that pure-rose.css positions the fixed header
  // stack with, on every template (the homepage additionally layers a
  // transparent-over-hero look on top via its own `.template-index` CSS).
  function setAnnounceOffset() {
    var bar = document.querySelector(".announcement-bar-section");
    var header = document.querySelector(".section-header");
    var height = bar ? bar.offsetHeight : 35;
    document.documentElement.style.setProperty("--pr-announce-height", height + "px");
    if (header) {
      document.documentElement.style.setProperty("--header-height", header.offsetHeight + "px");
    }
  }

  setAnnounceOffset();
  window.addEventListener("resize", setAnnounceOffset);

  if ("ResizeObserver" in window) {
    var announceBar = document.querySelector(".announcement-bar-section");
    var headerEl = document.querySelector(".section-header");
    var sizeObserver = new ResizeObserver(setAnnounceOffset);
    if (announceBar) sizeObserver.observe(announceBar);
    if (headerEl) sizeObserver.observe(headerEl);
  }

  document.body.classList.toggle("pr-header-solid", window.scrollY >= 100);

  var lastScrollTop = 0;
  var navDelta = 3;
  var mobileNav = window.matchMedia("(max-width: 767px)");

  function headerStackHeight() {
    var bar = document.querySelector(".announcement-bar-section");
    var header = document.querySelector(".section-header");
    return (bar ? bar.offsetHeight : 0) + (header ? header.offsetHeight : 0);
  }

  function syncMobileNav(st) {
    if (!mobileNav.matches) {
      document.body.classList.remove("pr-nav-up");
      lastScrollTop = st;
      return;
    }

    if (document.querySelector(".section-header.menu-open")) {
      document.body.classList.remove("pr-nav-up");
      lastScrollTop = st;
      return;
    }

    if (Math.abs(lastScrollTop - st) <= navDelta) return;

    if (st > lastScrollTop && st > headerStackHeight()) {
      document.body.classList.add("pr-nav-up");
    } else if (st + window.innerHeight < document.documentElement.scrollHeight) {
      document.body.classList.remove("pr-nav-up");
    }

    lastScrollTop = st;
  }

  var headerDidScroll = false;
  window.addEventListener(
    "scroll",
    function () {
      document.body.classList.toggle("pr-header-solid", window.scrollY >= 100);
      headerDidScroll = true;
    },
    { passive: true }
  );

  setInterval(function () {
    if (!headerDidScroll) return;
    headerDidScroll = false;
    syncMobileNav(window.scrollY || document.documentElement.scrollTop);
  }, 250);

  mobileNav.addEventListener("change", function () {
    if (!mobileNav.matches) document.body.classList.remove("pr-nav-up");
  });

  var desktopMq = window.matchMedia("(min-width: 990px)");
  var group = document.querySelector("[data-pr-shop-nav]");
  var panel = document.querySelector("[data-pr-shop-panel]");
  var trigger = document.querySelector("[data-pr-shop-trigger]");
  var timer = null;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  // Returns a getter for the tab currently pressed, which the product-click
  // event reports. onSelect fires on the shopper's clicks only, not on the
  // initial render, so a selection event always means somebody chose a tab.
  function wireFilter(btns, items, attr, onSelect) {
    var current = null;
    function apply(btn) {
      current = btn.getAttribute(attr);
      var benefit = btn.getAttribute(attr);
      btns.forEach(function (item) {
        item.setAttribute("aria-pressed", item === btn ? "true" : "false");
      });
      items.forEach(function (card) {
        var has =
          benefit === "all" ||
          (" " + (card.getAttribute("data-benefits") || "") + " ").indexOf(" " + benefit + " ") > -1;
        card.classList.toggle("is-hidden", !has);
      });
    }

    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        apply(btn);
        if (onSelect) onSelect(current);
      });
    });

    var initial = null;
    btns.forEach(function (btn) {
      if (btn.getAttribute("aria-pressed") === "true") initial = btn;
    });
    if (initial) apply(initial);

    return function () {
      return current || "all";
    };
  }

  // The Shop menu funnel: shop.menu_opened -> shop.benefit_selected ->
  // shop.product_clicked, through Shopify.analytics.publish -> Social Ocean
  // pixel -> PostHog, surface desktop (header panel) or mobile (drawer). The
  // previous theme sent these with benefit values all / stress-relief / mood /
  // skin / hydration and this one sent none until Oct 2026; the tabs it
  // reports now are feel-good and look-good, so old and new never share a
  // value. Payload shape matches the old theme's so the backend reads both.
  function publishShop(name, properties, productId) {
    var shopify = window.Shopify;
    if (!(shopify && shopify.analytics && shopify.analytics.publish)) return;
    var payload = { url: window.location.href, properties: properties };
    if (productId) payload.productId = parseInt(productId, 10);
    try {
      shopify.analytics.publish(name, payload);
    } catch (err) {}
  }

  // The pixel posts with keepalive, so the event survives the page unloading
  // and the link is left to navigate normally.
  function trackProductClicks(links, surface, getBenefit) {
    links.forEach(function (link) {
      link.addEventListener("click", function () {
        publishShop(
          "shop.product_clicked",
          {
            surface: surface,
            benefit: getBenefit(),
            product_handle: link.getAttribute("data-product-handle") || null,
            product_title: link.getAttribute("data-product-title") || null
          },
          link.getAttribute("data-product-id")
        );
      });
    });
  }

  function open() {
    if (!desktopMq.matches) return;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (panel && !panel.classList.contains("is-open")) {
      publishShop("shop.menu_opened", { surface: "desktop" });
    }
    if (panel) panel.classList.add("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    document.body.classList.add("pr-shop-nav-open", "pr-shop-nav-solid");
  }

  // Opens from the homepage hero's desktop Shop now are reported as
  // shop_now.opened / shop_now.closed (surface header_panel), matching the
  // phone sheet's events in pure-rose-rotator.js. Only those: hovering or
  // clicking the header's own Shop link is ordinary navigation and stays
  // out of the numbers.
  var heroSession = null;

  function publishShopNow(name, properties) {
    var shopify = window.Shopify;
    if (!(shopify && shopify.analytics && shopify.analytics.publish)) return;
    var visitor = document.cookie.match(/(?:^|; )_shopify_y=([^;]*)/);
    shopify.analytics.publish("shop_now." + name, {
      visitorId: visitor ? decodeURIComponent(visitor[1]) : null,
      properties: properties
    });
  }

  function reportHeroClose(method) {
    if (!heroSession) return;
    publishShopNow("closed", {
      trigger: heroSession.trigger,
      surface: "header_panel",
      method: method,
      open_ms: Date.now() - heroSession.at
    });
    heroSession = null;
  }

  function close(method) {
    reportHeroClose(method || "other");
    if (panel) panel.classList.remove("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    document.body.classList.remove("pr-shop-nav-open", "pr-shop-nav-solid");
  }

  function scheduleClose() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      close("mouseleave");
    }, 220);
  }

  if (group && panel) {
    group.addEventListener("mouseenter", open);
    group.addEventListener("mouseleave", scheduleClose);
    panel.addEventListener("mouseenter", open);
    panel.addEventListener("mouseleave", scheduleClose);

    if (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        open();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") close("escape");
    });

    document.addEventListener("click", function (event) {
      if (!group.contains(event.target)) close("outside_click");
    });

    // The hero's desktop Shop now (pr-hero-banner.liquid) opens this panel.
    // The click is stopped here so the outside-click handler above doesn't
    // close the panel on the same click that opened it. Below the desktop
    // breakpoint there is no panel, so the link just follows its href.
    slice(document.querySelectorAll("[data-pr-shop-nav-open]")).forEach(function (link) {
      link.addEventListener("click", function (event) {
        if (!desktopMq.matches) return;
        event.preventDefault();
        event.stopPropagation();
        openFromShopNow("hero_desktop");
      });
    });

    function openFromShopNow(trigger) {
      var wasOpen = panel.classList.contains("is-open");
      open();
      if (!wasOpen && !heroSession) {
        heroSession = { trigger: trigger, at: Date.now() };
        publishShopNow("opened", { trigger: trigger, surface: "header_panel" });
      }
    }

    // /?shop-now=1 opens the panel on arrival, as the hero's Shop Now
    // would. The empty Rebuy cart's Shop Now links here, so a visitor with
    // nothing in the cart lands on the four products rather than a
    // collection page (28 Oct 2026). Phones get the sheet instead, from
    // pure-rose-rotator.js. The param comes off the URL after load, so a
    // refresh or a shared link doesn't open it again.
    if (desktopMq.matches && /(?:^|[?&])shop-now=1(?:&|$)/.test(location.search)) {
      openFromShopNow("cart_empty");
    }

    panel.addEventListener("click", function (event) {
      if (event.target.closest && event.target.closest("a[href]")) reportHeroClose("product");
    });

    var desktopBenefit = wireFilter(
      slice(panel.querySelectorAll("[data-pr-benefit]")),
      slice(panel.querySelectorAll("[data-benefits]")),
      "data-pr-benefit",
      function (benefit) {
        publishShop("shop.benefit_selected", { surface: "desktop", benefit: benefit });
      }
    );
    trackProductClicks(slice(panel.querySelectorAll("a[data-product-id]")), "desktop", desktopBenefit);
  }

  desktopMq.addEventListener("change", function () {
    if (!desktopMq.matches) close("resize");
  });

  var mobileToggle = document.querySelector("[data-pr-shop-mtoggle]");
  var mobileSub = document.querySelector("[data-pr-shop-msub]");
  if (mobileToggle && mobileSub) {
    mobileToggle.addEventListener("click", function () {
      var isOpen = mobileSub.classList.toggle("is-open");
      mobileToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  // Every copy of the phone shop list (pr-shop-mnav-body.liquid): the drawer's,
  // and on the homepage the Shop all sheet's. Each filters only its own rows.
  // Only the drawer's copy reports shop.* events, as the old theme's did; the
  // sheet has no tabs and is measured by shop_now.* and pr_src instead.
  slice(document.querySelectorAll(".pr-shop-mnav__inner")).forEach(function (inner) {
    var inDrawer = !!inner.closest("[data-pr-shop-msub]");
    var getBenefit = wireFilter(
      slice(inner.querySelectorAll("[data-pr-mbenefit]")),
      slice(inner.querySelectorAll("[data-benefits]")),
      "data-pr-mbenefit",
      inDrawer
        ? function (benefit) {
            publishShop("shop.benefit_selected", { surface: "mobile", benefit: benefit });
          }
        : null
    );
    if (inDrawer) {
      trackProductClicks(slice(inner.querySelectorAll("a[data-product-id]")), "mobile", getBenefit);
    }
  });

  // The drawer opens with its Shop list already expanded, so opening the
  // drawer is opening the Shop menu on phones.
  var drawerDetails = document.getElementById("Details-menu-drawer-container");
  if (drawerDetails) {
    new MutationObserver(function () {
      if (drawerDetails.hasAttribute("open")) publishShop("shop.menu_opened", { surface: "mobile" });
    }).observe(drawerDetails, { attributes: true, attributeFilter: ["open"] });
  }

  // The in-drawer close button isn't Dawn's own <summary> toggle, so route
  // its click through the summary's existing click handler (global.js) to
  // get the real close behavior: scroll unlock, focus trap teardown, etc.
  var drawerClose = document.querySelector("[data-pr-drawer-close]");
  if (drawerClose) {
    drawerClose.addEventListener("click", function () {
      var details = document.getElementById("Details-menu-drawer-container");
      var summary = details && details.querySelector("summary");
      if (summary) summary.click();
    });
  }

  // ---------- shop-nav ratings badge (desktop: 4.9 5★ + count · mobile: 4.9 5★ · count) ----------
  function formatRatingCount(n, compact) {
    n = Math.round(Number(n) || 0);
    if (!compact || n < 10000) {
      try {
        return n.toLocaleString("en-US");
      } catch (e) {
        return String(n);
      }
    }
    var k = n / 1000;
    var s = (k >= 100 ? k.toFixed(0) : k.toFixed(1)).replace(/\.0$/, "");
    return s + "k";
  }

  function hasRatings(row) {
    if (!row) return false;
    var n = Number(row.ratings_count);
    return !isNaN(n) && n > 0;
  }

  // The shop menus show stars and the review count, not the average: the
  // client dropped the 4.9 / 5.0 figures from the header panel, the drawer and
  // the homepage sheet (review call, Sep 29) -- the count carries the proof,
  // and the averages read as near-identical noise across four products. The
  // average stays in the aria-label, where it costs nothing visually. The PDP
  // header line (paintPdpRating) keeps its average.
  function ratingLabel(row) {
    return (
      (row.rating != null ? row.rating + " out of 5 stars, " : "") +
      formatRatingCount(row.ratings_count, false) + " ratings"
    );
  }

  function paintDesktopRating(el, row) {
    if (!hasRatings(row)) return;
    var stars = document.createElement("span");
    stars.className = "pr-shop-nav__rating-stars";
    stars.setAttribute("aria-hidden", "true");
    stars.textContent = "★★★★★";
    var count = document.createElement("span");
    count.className = "pr-shop-nav__rating-count";
    count.textContent = formatRatingCount(row.ratings_count, false);
    el.textContent = "";
    el.appendChild(stars);
    el.appendChild(count);
    el.removeAttribute("hidden");
    el.setAttribute("aria-label", ratingLabel(row));
    el.classList.add("is-ready");
  }

  function paintMobileRating(el, row) {
    if (!hasRatings(row)) return;
    var star = document.createElement("span");
    star.className = "pr-shop-mnav__rating-star";
    star.setAttribute("aria-hidden", "true");
    star.textContent = "★★★★★";
    var count = document.createElement("span");
    count.className = "pr-shop-mnav__rating-count";
    count.textContent = formatRatingCount(row.ratings_count, true);
    el.textContent = "";
    el.appendChild(star);
    el.appendChild(count);
    el.removeAttribute("hidden");
    el.setAttribute("aria-label", ratingLabel(row));
    el.classList.add("is-ready");
  }

  // PDP header line (stars + count under the title): swap the server-rendered
  // placeholder average for the live one. Count-up of the review count is
  // handled separately by star-review-countup.
  function paintPdpRating(el, row) {
    if (!row || row.rating == null) return;
    el.textContent = Number(row.rating).toFixed(1);
  }

  function applyShopNavRatings(rows) {
    if (!rows || !rows.length) return;
    var byHandle = {};
    rows.forEach(function (r) {
      if (r && r.handle) byHandle[r.handle] = r;
    });

    slice(document.querySelectorAll(".pr-shop-nav__card[data-product-handle]")).forEach(function (card) {
      var row = rowFor(card, byHandle);
      var el = card.querySelector("[data-shop-rating]");
      if (el) paintDesktopRating(el, row);
    });
    slice(document.querySelectorAll(".pr-shop-mnav__row[data-product-handle]")).forEach(function (card) {
      var row = rowFor(card, byHandle);
      var el = card.querySelector("[data-shop-rating]");
      if (el) paintMobileRating(el, row);
    });
    slice(document.querySelectorAll(".pr-pdp__stars[data-product-handle]")).forEach(function (link) {
      var ritual = link.getAttribute("data-ritual-handles");
      var row = ritual ? ritualAggregate(ritual, byHandle) : byHandle[link.getAttribute("data-product-handle")];
      var el = link.querySelector("[data-pdp-rating-avg]");
      if (el) paintPdpRating(el, row);
      if (ritual) paintPdpRitualCount(link, row);
    });
  }

  // A card or link carrying data-ritual-handles (the Trial Pack, a ritual) is
  // rated by its contents; everything else by its own handle.
  function rowFor(el, byHandle) {
    var ritual = el.getAttribute("data-ritual-handles");
    return ritual ? ritualAggregate(ritual, byHandle) : byHandle[el.getAttribute("data-product-handle")];
  }

  // A ritual has no reviews of its own -- it wraps three established products --
  // so it reports its contents: the mean of the components' averages and the
  // sum of their counts. An unrated component is skipped rather than counted as
  // zero, which would drag the average down for a product nobody has reviewed.
  function ritualAggregate(attr, byHandle) {
    var sum = 0;
    var rated = 0;
    var count = 0;
    (attr || "").split(",").forEach(function (h) {
      var row = byHandle[h.trim()];
      if (!row) return;
      if (row.rating != null) {
        sum += Number(row.rating);
        rated += 1;
      }
      count += Math.round(Number(row.ratings_count) || 0);
    });
    if (!rated || !count) return null;
    return { rating: sum / rated, ratings_count: count };
  }

  // Every other PDP leaves its count to star-review-countup, which rolls it up
  // to Social Ocean's figure for the page's own handle. A ritual has no figure
  // of its own, so its count is written here instead.
  function paintPdpRitualCount(link, row) {
    var el = link.querySelector("[data-pdp-rating-count]");
    if (!el || !row || !row.ratings_count) return;
    el.textContent = formatRatingCount(row.ratings_count, false) + " reviews";
  }

  function loadShopNavRatings() {
    var handles = [];
    slice(document.querySelectorAll("[data-product-handle]")).forEach(function (el) {
      var h = el.getAttribute("data-product-handle");
      if (h && handles.indexOf(h) === -1) handles.push(h);
    });
    slice(document.querySelectorAll("[data-ritual-handles]")).forEach(function (el) {
      (el.getAttribute("data-ritual-handles") || "").split(",").forEach(function (h) {
        h = h.trim();
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
    });
    var shopDomain = window.Shopify && window.Shopify.shop;
    if (!shopDomain || !handles.length) return;

    var url =
      "https://api.socialocean.co/api/widget/shop-nav/products" +
      "?shop=" + encodeURIComponent(shopDomain) +
      "&handles=" + encodeURIComponent(handles.join(","));
    fetch(url, { credentials: "omit", headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (json) {
        var rows = json && (json.data || json);
        if (Array.isArray(rows)) applyShopNavRatings(rows);
      })
      .catch(function () {
        /* ratings are progressive enhancement */
      });
  }

  // ---------- lock the panel + spinner-on-card once a Shop product is clicked ----------
  function lockOnNavigate(container, links) {
    if (!container) return;
    links.forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (e.defaultPrevented) return;
        e.preventDefault();
        container.classList.add("is-navigating");
        a.classList.add("is-loading");
        var href = a.href;
        setTimeout(function () {
          window.location.assign(href);
        }, 200);
      });
    });
  }

  lockOnNavigate(
    document.querySelector("[data-pr-shop-panel]"),
    slice(document.querySelectorAll(".pr-shop-nav__card"))
  );
  slice(document.querySelectorAll(".pr-shop-mnav__sub")).forEach(function (sub) {
    lockOnNavigate(sub, slice(sub.querySelectorAll(".pr-shop-mnav__row")));
  });

  window.addEventListener("pageshow", function () {
    slice(document.querySelectorAll(".is-navigating")).forEach(function (x) {
      x.classList.remove("is-navigating");
    });
    slice(document.querySelectorAll(".is-loading")).forEach(function (x) {
      x.classList.remove("is-loading");
    });
  });

  loadShopNavRatings();

  // Rebuy's empty-cart text is a rich-text editor that writes every link
  // with target="_blank", so its Shop Now opened the homepage in a new tab
  // (28 Oct 2026). Any shop-now link opens in this tab instead. Capture
  // phase, so it runs before Rebuy's own handlers inside the cart.
  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest && event.target.closest('a[href*="shop-now=1"]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
      event.preventDefault();
      window.location.href = link.href;
    },
    true
  );

  document.addEventListener("DOMContentLoaded", function () {
    if (!/(?:^|[?&])shop-now=1(?:&|$)/.test(location.search)) return;
    var url = new URL(location.href);
    url.searchParams.delete("shop-now");
    history.replaceState(history.state, "", url.pathname + url.search + url.hash);
  });
})();
